import React, { Dispatch, SetStateAction } from "react";
import { HorizontalLeftAlignedContainer } from "../../styles/container";
import { COLORS } from "../../styles/colors";
import { getBorderRadius } from "../../utils";
import { ITEM_HORIZONTAL_SPACING } from "../../styles/spacing";
import { EditTitle } from "./EditTitle";
import { useNavigation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

export type TitledTextareaProps = {
  title: string;
  formDataName: string;
  value: string;
  setText: Dispatch<SetStateAction<string>>;
  maxLength: number;
  placeholderText: string;
  required?: boolean;
};
export const TitledTextarea = (props: TitledTextareaProps) => {
  const {
    title,
    formDataName,
    value,
    setText,
    maxLength,
    placeholderText,
    required,
  } = props;
  const colors = COLORS["light"];
  const navigation = useNavigation();

  return (
    <div
      style={{
        flex: 1,
        flexDirection: "column",
        width: "100%",
        // marginLeft: ITEM_HORIZONTAL_SPACING,
        // marginRight: ITEM_HORIZONTAL_SPACING,
      }}
    >
      <EditTitle title={title} required={required} />
      {navigation.state === "loading" ? (
        <Skeleton height={120} />
      ) : (
        <HorizontalLeftAlignedContainer>
          <textarea
            rows={5}
            cols={50}
            name={formDataName}
            value={value}
            onChange={(e) => {
              setText(e.target.value);
            }}
            placeholder={placeholderText}
            maxLength={maxLength}
            style={{
              flex: 1,
              borderRadius: getBorderRadius("small", "rounded rect"),
              borderWidth: 1,
              borderColor: colors.LIGHT_GRAY,
              padding: 8,
              outline: "none",
            }}
          />
        </HorizontalLeftAlignedContainer>
      )}
    </div>
  );
};
